import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import ErrorMessage from "../../common/errormsg/ErrorMessage";
import Api_Instance from "../../api/Api_Instance";
import CountriesApi from "../../common/countriesapi/CountriesApi";
import { Contactstartup } from "../../api/endpoints";
import {
  INVESTMENT_RANGE,
  PROFILE_TYPE,
  PURCHASE_TIME,
} from "../../utils/Utils";
import CompanyLogo from "../../common/CompanyLogo";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Startupdetails() {
  const Location = useLocation();
  const api = Api_Instance.useApi();
  const { useCountries, States, Ctiy } = CountriesApi;
  const [errors, setErrors] = useState({});
  const item = Location?.state?.item;
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    investment: "",
    company: "",
    terms_conditions: false,
    purchase_time: "",
    profile_type: "",
    comments: "",
    startup: item?.id
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleCountryChange = (event) => {
    const { value, selectedIndex } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      country: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };

  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormData((prevValues) => ({
      ...prevValues,
      state: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = validate(formData);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        const res = await api("POST", Contactstartup.POST_CONTACT, formData);
        if (res.status) {
          setFormData({
            name: "",
            email: "",
            phone: "",
            country: "",
            state: "",
            city: "",
            investment: "",
            company: "",
            terms_conditions: false,
            purchase_time: "",
            profile_type: "",
            comments: "",
            startup: ""
          })
          toast.success(res.data.message || "Successfully Create");
        }
      }
    } catch (error) {
      if (error?.response?.data?.code === "token_not_valid") {
        toast.error("Session expired please login again");
      } else if (
        error?.response?.data?.detail ===
        "Authentication credentials were not provided."
      ) {
        toast.error("please login you are not authorized");
      } else {
        toast.error(error.message || "invalid data");
      }
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formData,
      [name]: value,
    });
    setErrors(validationErrors);
  };
  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "name",
      "email",
      "phone",
      "email",
      "country",
      "country",
      "state",
      "city",
      "investment",
      "company",
      "purchase_time",
      "profile_type",
      "comments",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];

      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        errors[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });
    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email address is invalid";
    }
    if (values.phone && !/^\d{10}$/.test(values.phone)) {
      errors.phone = "phone No is invalid";
    }
    if (!values.terms_conditions) {
      errors.terms_conditions = "Please agree to the Terms & Conditions."
    }
    return errors;
  };
  console.log('item?.brand_name', item)
  return (
    item && (
      <div>
        <CompanyLogo title={"High Growth Potential Startups"} subtitle={"High Growth Potential Startups"} />
        <div className="w-full  max-w-[1250px]      mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className=" flex md:flex-row flex-col ">
            <div className="flex flex-col items-center md:flex-row w-full mx-auto mt-4 gap-3 py-2">
              <div className="border border-subtext_color rounded-md">
                <img
                  src={`${item?.business_pic}`}
                  alt="img"
                  className="object-fill border border-subtext_color max-w-[120px] min-w-[120px] h-[80px] p-2 "
                />
              </div>
              <div className="flex flex-col justify-center items-center ">
                <p className="text-lg font-semibold">{item?.sector}</p>
              </div>
            </div>

          </div>

          <div className="flex 2xl:flex-col xl:flex-col lg:flex-col md:flex-col flex-row gap-4 overflow-y-auto">
            <div className="flex flex-col items-start 2xl:w-[70%] xl:w-[70%] lg:w-[70%] w-[100%] h-[80%]">
              <div className="bg-card_bg_color p-4 rounded-lg border h-[600px] w-[100%] mb-4">
                <div className="h-[600px] w-[100%]">
                  <img
                    src={`${item?.business_pic}`}
                    alt="upload logo"
                    className="h-[550px] w-[100%] mx-auto"
                  />
                </div>

              </div>
              <div className="flex justify-around rounded-sm p-3 w-full !bg-[#FAFAFA]">
                <div className="border-r-2 border-[#D9D9D9] w-[33.33%] text-center">
                  <div className="flex flex-col space-y-2">
                    <p className="text-[#4A5661] 2xl:text-[20px] xl:text-[20px] lg:text-[16px] text-[16px] font-medium text-center mx-auto">{item?.inventory}</p>
                    <p className="text-[#5D6C72] text-center">Investment Size</p>
                  </div>
                </div>
                <div className="border-r border-[#D9D9D9] w-[33.33%] text-center">
                  <div className="flex flex-col space-y-2">
                    <p className="text-[#4A5661]  2xl:text-[20px] xl:text-[20px] lg:text-[16px] text-[16px] font-medium text-center">{item?.annual_sales}</p>
                    <p className="text-[#5D6C72] text-center">Annual Sales/Turnover</p>
                  </div>
                </div>
                <div className="w-[33.33%] text-center">
                  <div className="flex flex-col space-y-2">
                    <p className="text-[#4A5661] 2xl:text-[20px] xl:text-[20px] lg:text-[16px] text-[16px] font-medium text-center">{item?.income}</p>
                    <p className="text-[#5D6C72] text-center">Gross Income</p>
                  </div>
                </div>

              </div>

              <div className="w-full mt-5">
                <h2 className="text-[#222222] font-semibold text-lg">
                  Details
                </h2>
                <div className="overflow-x-auto min-w-full bg-card_bg_color rounded-lg mt-3 py-2">
                  <table className="w-full">
                    <tbody className="w-full">
                      {/* <tr className="w-full">
                        <td className="  px-2 py-2 font-sm w-[50%]">
                          Establishment Year
                        </td>
                        <td className=" px-2 py-2  w-[50%]">{item?.year}</td>
                      </tr>
                      <tr>
                        <td className="  px-2 py-2 font-sm w-[50%]">Employees</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.employees}</td>
                      </tr>
                      <tr>
                        <td className="  px-2 py-2 font-sm w-[50%]">Entity Type</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.entity}</td>
                      </tr> */}
                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">Name</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.name}</td>
                      </tr>
                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">Email</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.email}</td>
                      </tr>
                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">Phone</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.phone}</td>
                      </tr>

                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">Business Sector</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.sector}</td>
                      </tr>
                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">Business Type</td>
                        <td className=" px-3 py-2  w-[50%]">{item?.business_type}</td>
                      </tr>
                      <tr>
                        <td className="  px-3 py-2 font-sm w-[50%]">
                          Social Media Links
                        </td>
                        <td className=" px-3 py-2  w-[50%]">{item?.facebook}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-full mt-5">
                <h2 className="text-[#222222] font-semibold text-lg">
                  Financial
                </h2>
                <div className="overflow-x-auto min-w-full bg-card_bg_color rounded-lg mt-3 p-2">
                  <table className="W-[100%] w-full	 max-w-[100%]">
                    <tbody className="W-[100%]  w-full	max-w-[100%]">
                      <tr className="W-[100%]  w-full	max-w-[100%]">
                        <td className="px-3 py-2 font-sm w-[50%]">Annual Sales</td>
                        <td className="px-2 py-2  w-[50%]">{item?.annual_sales}</td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">EBITDA</td>
                        <td className=" px-2 py-2 w-[50%]">{item?.ebitda}</td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">EBITDA Margin</td>
                        <td className="px-2 py-2 w-[50%]">{item?.ebitda_margin}</td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">Inventory Value</td>
                        <td className="px-2 py-2 w-[50%]">{item?.inventory}</td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">Rentals</td>
                        <td className="px-2 py-2 w-[50%]">{item?.rentals}</td>
                      </tr>
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">Gross Income</td>
                        <td className="px-2 py-2 w-[50%]">{item?.income}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-full mt-5">
                <h2 className="text-[#222222] font-semibold text-lg">
                  Business Requirement
                </h2>
                <div className="overflow-x-auto min-w-full bg-card_bg_color rounded-lg mt-3 py-2">
                  <table className="">
                    <tbody>
                      {/* <tr>
                        <td className="  px-2 py-2 font-sm w-[50%]">
                          One-line Business Pitch
                        </td>
                        <td className=" px-2 py-2  w-[50%]">{item?.one_line_pitch}</td>
                      </tr>
                      <tr>
                        <td className="  px-2 py-2 font-sm w-[50%]">Looking For</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.nature_entity}</td>
                      </tr> */}
                      <tr>
                        <td className="px-3 py-2 font-sm w-[50%]">Amount</td>
                        <td className="px-3 py-2 w-[50%]">{item?.income}</td>
                      </tr>
                      {/* <tr>
                        <td className="  px-2 py-2 font-sm w-[50%]">Reason</td>
                        <td className=" px-2 py-2  w-[50%]">{item?.entity}</td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="2xl:w-[30%] xl:w-[30%] lg:w-[30%] md:w-[30%] w-[100%]">
              {/* form */}
              <div className="">
                <form
                  className="max-w-md mx-auto p-4 bg-card_bg_color rounded-md"
                  onSubmit={handleSubmit}
                  onBlur={handleBlur}
                >
                  <h2 className="mb-3 text-xl">Apply for startup</h2>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Name <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="w-full p-2 border border-gray-300 rounded mt-1 "
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <ErrorMessage error={errors.name} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Email <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && <ErrorMessage error={errors.email} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Enter phone Number{" "}
                      <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="number"
                      name="phone"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.phone && <ErrorMessage error={errors.phone} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Company <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      name="company"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.company}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.company && <ErrorMessage error={errors.company} />}
                  </div>

                  {/* <div className="mb-4">
                      <label className="block text-gray-700">
                        Pincode <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        name="pincode"
                        className="w-full p-2 border border-gray-300 rounded mt-1"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                      {errors.pincode && <ErrorMessage error={errors.pincode} />}
                    </div>
                    <div className="mb-4">
                      <label className="block text-gray-700">
                        Address <span className="text-star_color">*</span>
                      </label>
                      <textarea
                        name="address"
                        className="w-full p-2 border border-gray-300 rounded mt-1"
                        value={formData.address}
                        onChange={handleChange}
                      />
                      {errors.address && <ErrorMessage error={errors.address} />}
                    </div> */}
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Investment
                      <span className="text-star_color">*</span>
                    </label>

                    <select
                      id="investment"
                      name="investment"
                      value={formData.investment}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-select w-full p-2 border border-gray-300 rounded mt-1 "
                    >
                      <option value="" disabled>
                        Investment
                      </option>
                      {INVESTMENT_RANGE.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>
                    {errors.investment && (
                      <ErrorMessage error={errors.investment} />
                    )}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Purchase_time
                      <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="purchase_time"
                      className="w-full p-2 border border-gray-300 rounded mt-1 "
                      value={formData.purchase_time}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Purchase_time</option>
                      {PURCHASE_TIME.map((item) => (
                        <option value={item.label}>{item.value}</option>
                      ))}
                    </select>
                    {errors.purchase_time && (
                      <ErrorMessage error={errors.purchase_time} />
                    )}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Profile type <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="profile_type"
                      className="w-full p-2 border border-gray-300 rounded mt-1 "
                      value={formData.profile_type}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Profile type</option>
                      {PROFILE_TYPE.map((item) => (
                        <option value={item.label}>{item.value}</option>
                      ))}
                    </select>
                    {errors.profile_type && (
                      <ErrorMessage error={errors.profile_type} />
                    )}
                  </div>

                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Select Country <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="country"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.country}
                      onChange={handleCountryChange}
                      onBlur={handleBlur}
                    >
                      <option value="">
                        Select country <span className="text-star_color">*</span>
                      </option>
                      {countries?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.country && <ErrorMessage error={errors.country} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Select State <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="state"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.state}
                      onChange={handleStateChange}
                      onBlur={handleBlur}
                    >
                      <option value="">
                        Select State <span className="text-star_color">*</span>
                      </option>
                      {statedata?.map((item) => (
                        <option value={item.name} data-id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {errors.state && <ErrorMessage error={errors.state} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Select City <span className="text-star_color">*</span>
                    </label>
                    <select
                      name="city"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.city}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select City</option>
                      {citydata?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.city && <ErrorMessage error={errors.city} />}
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">
                      Comments <span className="text-star_color">*</span>
                    </label>
                    <textarea
                      name="comments"
                      className="w-full p-2 border border-gray-300 rounded mt-1"
                      value={formData.comments}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.comments && <ErrorMessage error={errors.comments} />}
                  </div>

                  <div className="mb-4">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="terms_conditions"
                        className="form-checkbox "
                        checked={formData.terms_conditions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <span className="ml-2 text-gray-700">
                        I agree to the Terms & Conditions
                      </span>
                    </label>
                    {errors.terms_conditions && <ErrorMessage error={errors.terms_conditions} />}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="w-full bg-primaryColor p-2 rounded button button4"
                    >
                      Contact Startup
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row  mt-5 gap-4 xl:w-[100%]">
            <div className="flex flex-col xl:w-2/3 lg:w-2/3 md:w-2/3  w-full">
              {/* <div className="bg-card_bg_color p-4 overflow-y-auto h-[300px] overflow-auto rounded-lg border ">
                <h2 className="text-2xl font-semibold">Overview</h2>
                <p className="mt-2 text-subtext_color">
                  {item?.company_summary}
                </p>

              </div> */}



            </div>


          </div>
        </div>
      </div>
    )
  );
}

export default Startupdetails;
